// Bloc du tableau de bord : résultat de l'année (flux), pièces à classer, contrats à renouveler, délais d'AG.
import { Link } from "react-router";
import { useGet } from "@core/hooks";
import { date } from "@core/format";
import { Card, ErrorBox, Loading, Stat } from "@core/ui";
import { Amount, orgApi } from "./shared";

type Dash = {
  year: number;
  receipts_cents: number;
  expenses_cents: number;
  result_cents: number;
  unallocated_cents: number;
  missing_documents: number;
  contracts_due: { id: string; supplier: string; kind_label: string; property_label: string | null; deadlines: { notice_deadline: string | null; days_to_notice: number | null }; dates_confirmed: boolean }[];
  inbox_pending: number;
  meeting_deadlines: { id: string; title: string; building_label: string; contest_deadline: string }[];
};

export function FinanceDashboard({ orgId }: { orgId: string }) {
  const q = useGet<Dash>(orgApi(orgId, "/finance/dashboard"));
  const to = (p: string) => `/espace/${orgId}/${p}`;
  const d = q.data;
  return (
    <Card title={d ? `Finances ${d.year}` : "Finances"}>
      {q.isLoading ? <Loading /> : null}
      <ErrorBox error={q.error} />
      {d ? (
        <>
          <div className="stats">
            <Stat label="Encaissé" value={<Amount cents={d.receipts_cents} />} />
            <Stat label="Payé" value={<Amount cents={d.expenses_cents} />} />
            <Stat label="Solde de l’année" value={<Amount cents={d.result_cents} />} hint="Flux de trésorerie, pas un résultat fiscal" />
          </div>
          <ul className="list-plain small">
            {d.missing_documents ? (
              <li>
                <Link to={to("finances/recettes-et-depenses")}>{d.missing_documents} opération{d.missing_documents > 1 ? "s" : ""} sans justificatif</Link>
              </li>
            ) : null}
            {d.inbox_pending ? (
              <li>
                <Link to={to("finances/boite-de-reception")}>{d.inbox_pending} pièce{d.inbox_pending > 1 ? "s" : ""} à classer</Link>
              </li>
            ) : null}
            {d.contracts_due.map((c) => (
              <li key={c.id}>
                <Link to={to("finances/contrats")}>
                  {c.kind_label} — {c.supplier}
                </Link>{" "}
                : résiliation possible jusqu’au {date(c.deadlines.notice_deadline)}
                {c.property_label ? ` (${c.property_label})` : ""}
                {c.dates_confirmed ? "" : ", dates à confirmer"}
              </li>
            ))}
            {d.meeting_deadlines.map((m) => (
              <li key={m.id}>
                <Link to={to("immeubles/assemblees-generales")}>{m.title}</Link> ({m.building_label}) : contestation possible jusqu’au {date(m.contest_deadline)}
              </li>
            ))}
            {!d.missing_documents && !d.inbox_pending && !d.contracts_due.length && !d.meeting_deadlines.length ? <li className="muted">Rien à signaler côté finances.</li> : null}
          </ul>
        </>
      ) : null}
    </Card>
  );
}
